import { combine, withCallbacks, withContext } from 'react-hooks-combine'
import { spec, validators } from 'utils/validation'
import { withFormModel } from 'shared/hooks'
import { StoreContext } from 'store/context'

import BeneficiaryFormComponent from './component'

const { string, any, custom } = validators

export default combine(
  withContext('appStore', StoreContext),

  withFormModel((_state, { initialValues = {} }) => ({
    fullName: {
      readonly: true,
      initialValue: initialValues.fullName,
      alias: 'Sponsor Name',
      spec: spec.flow(string.isString, string.isNotEmpty, any.required),
    },

    contactFirstName: {
      readonly: true,
      initialValue: initialValues.contactFirstName,
      alias: 'Contact First Name',
      spec: spec.flow(string.isString, string.isNotEmpty, any.required),
    },

    contactLastName: {
      readonly: true,
      initialValue: initialValues.contactLastName,
      spec: spec.flow(string.isString),
    },

    email: {
      readonly: true,
      initialValue: initialValues.email,
      spec: spec.flow(
        string.isString,
        string.isEmail,
        string.isNotEmpty,
        any.required
      ),
    },

    taxId: {
      readonly: true,
      initialValue: initialValues.taxId,
      spec: spec.flow(string.isString),
    },

    address1: {
      readonly: true,
      alias: 'address1',
      initialValue: initialValues.address?.address1,
      spec: spec.flow(string.isString),
    },
    address2: {
      readonly: true,
      alias: 'address2',
      initialValue: initialValues.address?.address2,
      spec: spec.flow(string.isString),
    },
    city: {
      readonly: true,
      alias: 'city',
      initialValue: initialValues.address?.city,
      spec: spec.flow(string.isString),
    },
    state: {
      readonly: true,
      alias: 'state',
      initialValue: initialValues.address?.state,
      spec: spec.flow(string.isString),
    },
    zip: {
      readonly: true,
      alias: 'zip',
      initialValue: initialValues.address?.zip,
      spec: spec.flow(string.isString),
    },
    country: {
      readonly: true,
      alias: 'country',
      initialValue: initialValues.address?.country,
      spec: spec.flow(string.isString),
    },

    bankAccount: {
      initialValue: initialValues.bankAccount || '',
      readonly: !initialValues.bankAccount,
      alias: 'Bank Account',
      spec: spec.flow(string.isString),
    },

    website: {
      readonly: true,
      initialValue: initialValues.website || '',
      spec: spec.flow(string.isString),
    },

    password: spec.flow(string.isString, string.isNotEmpty, any.required),

    confirmation: spec.flow(
      string.isString,
      custom.matchProp('password'),
      string.isNotEmpty,
      any.required
    ),
  })),

  withCallbacks(
    {
      onSubmitForm:
        (_state, { onSubmit }) =>
        (entity) => {
          return onSubmit(entity)
        },
    },
    []
  )
)(BeneficiaryFormComponent)
